import { useState, useEffect, useCallback } from 'react';
import api from '../lib/api';
import { Bell, CheckCircle, Clock } from 'lucide-react';

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);

  const fetchNotifs = useCallback(async () => {
    try { const res = await api.get('/notifications/all'); setNotifications(res.data.notifications); } catch {}
  }, []);

  useEffect(() => { fetchNotifs(); }, [fetchNotifs]);

  // Auto-refresh
  useEffect(() => {
    const interval = setInterval(fetchNotifs, 15000);
    return () => clearInterval(interval);
  }, [fetchNotifs]);

  const markAllRead = async () => {
    try { await api.put('/notifications/mark-read'); fetchNotifs(); } catch {}
  };

  return (
    <div className="min-h-screen pb-28 p-4" style={{ background: 'var(--neon-bg)' }}>
      <div className="max-w-2xl mx-auto space-y-4">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-black" style={{ fontFamily: 'var(--font-heading)', color: 'var(--neon-text)' }}>
            <Bell size={20} className="inline mr-2" style={{ color: 'var(--neon-primary)' }} />
            Notifications
          </h1>
          <button data-testid="mark-all-read-btn" onClick={markAllRead}
            className="text-xs px-3 py-1 rounded-lg font-bold" style={{ background: 'var(--neon-elevated)', color: 'var(--neon-primary)' }}>
            Mark all read
          </button>
        </div>

        {notifications.length === 0 ? (
          <div className="glass-card rounded-2xl p-8 text-center">
            <Bell size={32} className="mx-auto mb-2" style={{ color: 'var(--neon-text-muted)' }} />
            <p className="text-sm" style={{ color: 'var(--neon-text-muted)' }}>No notifications yet</p>
          </div>
        ) : (
          <div className="space-y-2">
            {notifications.map((n, idx) => (
              <div key={n.id || idx} data-testid={`notification-${idx}`}
                className="glass-card rounded-xl p-4"
                style={{ borderLeft: `3px solid ${n.is_read ? 'var(--neon-text-muted)' : 'var(--neon-primary)'}`, opacity: n.is_read ? 0.7 : 1 }}>
                <div className="flex items-start justify-between mb-1">
                  <p className="font-bold text-sm" style={{ color: n.is_read ? 'var(--neon-text-secondary)' : 'var(--neon-text)' }}>
                    {n.title}
                  </p>
                  {n.is_read ? (
                    <CheckCircle size={14} style={{ color: 'var(--neon-text-muted)' }} />
                  ) : (
                    <span className="w-2 h-2 rounded-full" style={{ background: 'var(--neon-primary)' }} />
                  )}
                </div>
                <p className="text-xs mb-2" style={{ color: 'var(--neon-text-secondary)' }}>{n.message}</p>
                <p className="text-xs flex items-center gap-1" style={{ color: 'var(--neon-text-muted)' }}>
                  <Clock size={10} /> {new Date(n.created_at).toLocaleString()}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
